import { Navigate } from 'react-router-dom';

import { matchCompanySubdomain } from './helpers';
import { removeLocalStorageToken } from './helpers/localStorage';
import { isFullAccessRole } from './helpers/roleAccess';
import { useStoragedJwt } from './hooks/useDecodedJwt';

export default function PrivateRoute({
  children,
  allowedToBank = true,
  allowedToUser = true,
  allowedRoles,
}: {
  children: React.ReactElement;
  allowedToBank?: boolean;
  allowedToUser?: boolean;
  /**
   * Papéis (role) autorizados a esta rota para a hive RealPrice. admin sempre
   * passa. `undefined` = sem gating por papel (comportamento antigo). Protege
   * deep-link; o esconder do menu/abas é a barreira principal (RBAC REAL-3099).
   */
  allowedRoles?: number[];
}): JSX.Element {
  try {
    const decoded = useStoragedJwt();
    const companySubdomain = matchCompanySubdomain();

    if (decoded === null || decoded.expired) {
      removeLocalStorageToken();
      return <Navigate to="/login" />;
    }

    const companyData = decoded.user.companies.find(
      (company) => company.subdomain === companySubdomain
    );
    const isHiveOwner = companyData?.is_hive_owner || false;
    if (isHiveOwner && !allowedToBank) {
      return <Navigate to="*" />;
    }
    if (!isHiveOwner && !allowedToUser) {
      return <Navigate to="*" />;
    }

    const role = companyData?.role;
    if (
      isHiveOwner &&
      allowedRoles &&
      !isFullAccessRole(role) &&
      (role == null || !allowedRoles.includes(role))
    ) {
      return <Navigate to="*" />;
    }
    return children;
  } catch {
    return <Navigate to="/login" />;
  }
}
